import produce from 'immer';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { initialStates } from '../initial-states/initialStates';
import { KioskDataState } from '../initial-states/stateTypes';

const initialState = initialStates.kioskData.normalState;

const reducer = produce(
  (state: KioskDataState = initialState, action: Action) => {
    switch (action.type) {
      case ActionType.UPDATE_KIOSK_INSTALLATION:
        state.installation = action.payload;
        return state;
      case ActionType.KIOSK_DATA_RESET:
        return initialState;
      default:
        return state;
    }
  },
  initialState
);

export default reducer;
